import { FormBuilder, Validators } from '@angular/forms';
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HorizonsTeam } from 'src/app/core/models/horizons-team.model';
import { Router } from '@angular/router';
import { UserService } from 'src/app/core/services/user.service';
import { Location } from '@angular/common';
import { User } from 'src/app/core/models/user.model';
import * as utils from 'src/app/shared/helpers/utils';
import { ConfigService } from 'src/app/core/services/config.service';
import { CustomValidators } from 'src/app/shared/helpers/custom-validators';

@Component({
  selector: 'hbo-horizons-team-actions',
  templateUrl: './horizons-team-actions.component.html',
  styleUrls: ['./horizons-team-actions.component.scss']
})
export class HorizonsTeamActionsComponent implements OnInit, AfterViewInit {

  @Input() horizonsTeam!: HorizonsTeam;
  @Output() reload: EventEmitter<any> = new EventEmitter();
  @Output() callback: EventEmitter<any> = new EventEmitter();

  action = 'create';

  utils = utils;

  user: User = utils?.localStorageGetItem('user');

  horizonsTeamForm = this.formBuilder.nonNullable.group({
    id: [''],
    name: ['', Validators.required]
  });

  horizonsTeams:HorizonsTeam[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private userService: UserService,
    private location: Location,
    private configSvc: ConfigService
  ) {

  }

  ngOnInit() {
    if (!this.horizonsTeam) {
      this.horizonsTeam = { id: 0 } as HorizonsTeam;
    } else {
      this.action = 'edit';
    }

    if (this.action === 'create') this.getHorizonsTeams();
    else this.setHorizonsTeamNameUsedValidator(this.configSvc.currentConfigValue!.horizonsTeams!);
  }

  ngAfterViewInit() {
    if (this.horizonsTeam && this.horizonsTeam.id !== 0) {
      this.horizonsTeamForm.patchValue({
        id: this.horizonsTeam.id?.toString(),
        name: this.horizonsTeam.name
      });
    }

    // Disable form for non-owner and view-only users
    if (this.user.profileId !== 3) {
      this.horizonsTeamForm.disable();
    }

    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    tooltipTriggerList.forEach(tooltipTrigger => new window['bootstrap' as keyof typeof window].Tooltip(tooltipTrigger));
  }

  save() {
    this.horizonsTeamForm.markAllAsTouched();
    if (this.horizonsTeamForm.valid) {
      this.horizonsTeamForm.controls.name.patchValue(this.horizonsTeamForm.controls.name.value.trim());
      if (this.action === 'create') {
        this.userService.createHorizonsTeam({ ...this.horizonsTeamForm.value } as unknown as HorizonsTeam).subscribe(res => {
          this.configSvc.currentConfigValue.horizonsTeams?.push(res);
          this.configSvc.setConfigParamsValue('horizonsTeams', this.configSvc.currentConfigValue.horizonsTeams);
          this.router.navigate(['users/horizonsteams']);
        });
      } else if (this.action === 'edit') {
        this.userService.updateHorizonsTeam({ ...this.horizonsTeamForm.value } as unknown as HorizonsTeam).subscribe(res => {
          //this.reload.emit();
          utils.deepMerge(this.configSvc.currentConfigValue.horizonsTeams?.find((ht: HorizonsTeam) => ht.id === Number(this.horizonsTeamForm.controls.id.value)), res);
          this.configSvc.setConfigParamsValue('horizonsTeams', this.configSvc.currentConfigValue.horizonsTeams);
          this.callback.emit({ action: 'updated', result: res });
          console.log(this.configSvc.currentConfigValue.horizonsTeams);
        });
      }
    }
  }

  delete() {
    this.userService.deleteHorizonsTeam(this.horizonsTeam.id).subscribe(res => {

      this.reload.emit();


      switch (res.body) {
        case 'HORIZONSTEAMREFERENCED':
          //TO DO
          utils.toogleModal('#confirmationModal-horizonsTeam-delete', false)
          break;
        case 'HORIZONSTEAMDELETED':
          this.configSvc.currentConfigValue.horizonsTeams = this.configSvc.currentConfigValue.horizonsTeams?.filter((ht: HorizonsTeam) => ht.id !== this.horizonsTeam.id);
          this.configSvc.setConfigParamsValue('horizonsTeams', this.configSvc.currentConfigValue.horizonsTeams);
          this.callback.emit({ action: 'deleted' });
          break;
        default:
          break;
      }



    });
  }

  cancel() {
    if (this.action === 'create') {
      this.location.back();
    } else {
      this.reload.emit();
    }
  }

  getHorizonsTeams = () => {
      this.userService.getHorizonsTeams({ perPage: -1 }, true).subscribe(res => {
        console.log(res.data)
        this.configSvc.setConfigParamsValue('horizonsTeams', res.data);
        this.setHorizonsTeamNameUsedValidator(res.data);
        this.horizonsTeams = res.data;
      });
    }

  setHorizonsTeamNameUsedValidator = (_horizonsTeams: HorizonsTeam[]) => {
      this.horizonsTeamForm.get('name')!.addValidators([Validators.required, CustomValidators.horizonsTeamnameValidator(_horizonsTeams,this.horizonsTeam.name)]);
    }
}
